import React from 'react';
import { WarehouseOrderExpeditionShowDataForm } from '../../../../../app/models/WareHouseOrderExpedition';

interface Props {
  expeditionDataForm: WarehouseOrderExpeditionShowDataForm;
  fetching?: boolean;
}

const WarehouseOrderExpeditionShowForm: React.FC<Props> = ({
  expeditionDataForm,
  fetching = false,
}: Props) => {
  if (fetching) return <div>Cargando datos de expedición...</div>;

  return (
    <>


      {/* Origen */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Origen</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            name="origin"
            value={expeditionDataForm.origin ?? ''}
            readOnly
          />
        </div>
      </div>

      {/* Destino */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Destino</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            name="destiny"
            value={expeditionDataForm.destiny ?? ''}
            readOnly
          />
        </div>
      </div>

      {/* Tramo */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tramo</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            name="routeSegment"
            value={expeditionDataForm.route_segment?.name ?? ''}
            readOnly
          />
        </div>
      </div>

      {/* Tipo de Contenedor */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tipo de Contenedor</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            name="packingType"
            value={expeditionDataForm.packing_type ?? ''}
            readOnly
          />
        </div>
      </div>

      {/* Tarifa de Expedición */}
      {/* Tarifa de Expedición */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tarifa expedición</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-6">
              <input
                type="text"
                className="form-control"
                name="rate"
                value={
                  expeditionDataForm.rate != null
                    ? expeditionDataForm.rate.toLocaleString()
                    : ''
                }
                readOnly
              />
            </div>
            <div className="col-3">
              <input
                type="text"
                className="form-control"
                name="currency"
                value={expeditionDataForm.currency ?? ''}
                readOnly
              />
            </div>
            <div className="col-3">
              <input
                type="text"
                className="form-control"
                name="unit"
                value={expeditionDataForm.unit ?? ''}
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WarehouseOrderExpeditionShowForm;
